import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './reducer';
import saga from './sagas';

export const sagaMiddleware = createSagaMiddleware({
  onError(error) {
    console.error('Saga error:', error);
  },
});

export const history = createBrowserHistory();

const routingMiddleware = routerMiddleware(history);

const store = createStore(
  rootReducer(history),
  composeWithDevTools(applyMiddleware(sagaMiddleware, routingMiddleware))
);

sagaMiddleware.run(saga);

export default store;
